export const numbers = new RegExp(/^[0-9]+$/);
